import { Route, Routes } from "react-router-dom";
import PageLayout from "../layouts/PageLayout";
import PageSingleSlug from "../pages/page/PageSingleSlug";

export function PageRoutes() {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route path=":slug" element={<PageSingleSlug />} />
      </Route>
    </Routes>
  );
}
